import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { applyNavReduction } from 'lib/payoutOnlyNav';

export const useHeaderData = () => {
  const user = useSelector((state) => state.user);
  const header = useSelector((state) => state.header);
  const storeVersion = useSelector((state) => state.store.storeVersion);

  // The single seam feeding both SideNav and MobileNav, so the payout-only
  // allowlist is applied here rather than in the fetch. Doing it at read time
  // also keeps hydration order untouched: fetchHeaderLinks currently resolves
  // before fetchHeaderUserData, and swapping them would invert which of the two
  // account-menu sources wins even with the mode off.
  const reducedHeader = useMemo(
    () =>
      applyNavReduction(header, {
        payoutOnlyMode: header?.user?.payoutOnlyMode,
        creationDisabled: header?.user?.creationDisabled
      }),
    [header]
  );

  return {
    user,
    header: reducedHeader,
    storeVersion
  };
};

export default useHeaderData;
